import { Stack } from '@heathmont/moon-components';
import PageTitle from '~/client/shared/PageTitle';
import type { CasinoProviderGameFragment } from './graphql/ProvidersListQuery.generated';
import ProviderCard from './ProviderCard';
import ProviderContainer from './styles/ProviderContainer';
import useProviders from './useProviders';

const Providers: FC = () => {
  const { providers } = useProviders();

  return (
    <Stack>
      <PageTitle translateId="casino.menu_item.all_providers" />
      <ProviderContainer>
        {providers?.map((provider) => (
          <ProviderCard
            key={provider?.id}
            name={provider?.name || ''}
            handle={provider?.handle || ''}
            count={provider?.games?.totalCount ?? 0}
            games={
              provider?.games?.edges?.map(
                ({ node }) => node,
              ) as CasinoProviderGameFragment[]
            }
          />
        ))}
      </ProviderContainer>
    </Stack>
  );
};

export default Providers;
